export default function flashButton() {
  return {
    flash: false
  };
}
